<template>
  <div :class="{'modal':true, 'is-active':show}">
    <form name="loginForm" @submit.prevent="handleLogin">
    <div class="modal-background" @click="$emit('close-modal')"></div>
    <div class="modal-card">
        <header class="modal-card-head back-gradient-animation">
          <p class="modal-card-title has-text-white has-text-centered">Inicia sesión</p>
          <button class="delete" aria-label="close" @click="$emit('close-modal')"></button>
        </header>
        <section class="modal-card-body">
        <p class="help">Escribe cualquier usuario y contrasena</p> 
          <!-- USERNAME -->
          <div class="field">
            <p class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                placeholder="Nombre de usuario"
                name="username"
                id="id_username"
                v-model="user.username"
                v-validate="'required'"
              />

              <span class="icon is-small is-left">
                <fa icon="user" />
              </span>
            </p>
            <p class="help is-danger" v-if="errors.has('username')">{{ errors.first('username') }}</p>
          </div>
          <!-- USERNAME/ -->
          <!-- PASSWORD -->
          <div class="field">
            <div class="control">
              <div class="field has-addons">
                <p class="control has-icons-left is-expanded">
                  <input
                    class="input"
                    :type="hidePassword ? 'password':'text'"
                    placeholder="Contraseña"
                    name="password"
                    id="id_password"
                    v-model="user.password"
                    v-validate="'required'"
                  />

                  <span class="icon is-small is-left">
                    <fa icon="key" />
                  </span>
                </p>
                <p class="control" @click="hidePassword=!hidePassword">
                  <a class="button is-static">
                    <fa :icon="hidePassword?'eye-slash':'eye'" />
                  </a>
                </p>
              </div>
            </div>
            <p class="help is-danger" v-if="errors.has('password')">{{ errors.first('password') }}</p>
          </div>
          <!-- PASSWORD/ -->
        </section>
        <footer class="modal-card-foot back-gradient-animation">
          <div class="buttons has-addons is-right">
            <button class="button is-link is-inverted is-outlined" @click="$emit('close-modal')">Cancelar</button>
            <button :class="{'button is-link is-light':true, 'is-loading':loading}" type="submit">OK!</button>
          </div>
        </footer>
    </div>
    </form>
  </div>
</template>

<script>
import User from "../models/user";
import Swal from 'sweetalert2'
export default {
  name: "Login",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    redirectPath: {
      type:String,
      default:'cuenta'
    }
  },
  data: () => ({
    user: new User("", ""),
    hidePassword: true,
    loading: false
  }),
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    handleLogin() {
      this.loading = true;
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        if (this.user.username && this.user.password) {
          this.$store.dispatch("auth/login", this.user).then(
            data => {
              Swal.fire({
                position: 'top',
                icon: 'success',
                title: `¡Bienvenido ${data.user.username}!`,
                showConfirmButton: false,
                timer: 2000,
                showClass: {
                  popup: 'animated fadeInDown faster'
                },
                hideClass: {
                  popup: 'animated fadeOutUp faster'
                }
              }).then(()=>{
                this.$emit('close-modal')
                this.$router.push({ name: 'dashboard'})
              })
            },
            error => {
              this.loading = false;
              var thisError = error.response.data
              if ('code' in thisError) {
                if(thisError.code == "5001"){
                  Swal.fire({
                    icon: 'warning',
                    title: 'Cuenta baneada',
                    text: 'La cuenta se encuentra inactiva en estos momentos, para mayor información contacte con un administrador.'
                  })
                } else if (thisError.code == "5002") {
                  Swal.fire({
                    icon: 'warning',
                    title: 'Datos Inválidos',
                    text: 'No se ha logrado conectar con los datos ingresados, verifique e intente de nuevo.'
                  })
                } else {
                  Swal.fire({
                    icon: 'error',
                    title: 'Oops... ¡Algo ha salido mal!',
                    text: 'No se ha podido acceder a la cuenta.'
                  }) 
                }

              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Oops... ¡Algo ha salido mal!',
                  text: 'No se ha podido acceder a la cuenta.'
                })
              }
            }
          );
        }
      });
    }
  }
};
</script>

<style scoped>
@media screen and (min-width: 769px){
    .modal-content, .modal-card {
        width: 340px;
    }
}
@media screen and (max-width: 769px){
    .modal-content, .modal-card {
        width: 90%;
    }
}
.buttons {
  width: 100%;
}
.back-gradient-animation {
  background: linear-gradient(-45deg, black, #2c3e50, #23a6d5, #7498D5);
  background-size: 400% 400%;
  animation: gradient 15s ease infinite;
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
</style>